import type { NativeStackScreenProps } from "@react-navigation/native-stack";

export enum ROUTES {
  FARMER_360_HOME = "Farmer360Home",
  FARMERS_LIST = "FarmersList",
  EDIT_FARMER_DETAILS = "EditFarmerDetails",
  ADD_FARMER_DETAILS = "AddFarmerDetails",
  ORDERS_LISTING = "OrdersListing",
  ONGOING_CROPS_LISTING = "OngoingCropsListing",
  FARMER_PRODUCTS_LISTING = "FarmerProductsListing",
  DISEASE_DIAGNOSIS = "DiseaseDiagnosisScreen",
  START_DIAGNOSIS = "StartDiagnosis",
  DISEASE_TREATMENT = "DiseaseTreatment",
  DIAGNOSIS_RESULT = "DiagnosisResult",
  ADD_FARMER = "AddFarmer",
  PREVIOUS_DIAGNOSIS = "PreviousDiagnosis",
  ORDER_DETAILS = "OrderDetails",
  FARMER_CREDIT_DETAILS = "FarmerCreditDetails",
}

export enum SCREEN_NAMES {
  FARMER_360_HOME = "Farmer Profile",
  FARMERS_LIST = "Farmers List",
  EDIT_FARMER_DETAILS = "Edit Farmer Details",
  ADD_FARMER_DETAILS = "Add New Farmer",
  ORDERS_LISTING = "Orders",
  ONGOING_CROPS_LISTING = "Ongoing Crops",
  FARMER_PRODUCTS_LISTING = "Products used by farmer",
  DISEASE_DIAGNOSIS = "DiseaseDiagnosisScreen",
  START_DIAGNOSIS = "StartDiagnosis",
  DISEASE_TREATMENT = "DiseaseTreatment",
  DIAGNOSIS_RESULT = "DiagnosisResult",
  ADD_FARMER = "AddFarmer",
  PREVIOUS_DIAGNOSIS = "PreviousDiagnosis",
  ORDER_DETAILS = "OrderDetails",
  FARMER_CREDIT_DETAILS = "FarmerCreditDetails",
}

export type RootStackParamList = {
  [ROUTES.FARMER_360_HOME]: {
    farmerId: string;
    name: string;
    phoneNumber: string;
  };
  [ROUTES.FARMERS_LIST]: undefined;
  [ROUTES.DISEASE_DIAGNOSIS]: undefined;
  [ROUTES.ADD_FARMER]: undefined;
  [ROUTES.START_DIAGNOSIS]: {
    cropId: string;
  };
  [ROUTES.PREVIOUS_DIAGNOSIS]: undefined;
  [ROUTES.EDIT_FARMER_DETAILS]: {
    farmerId: string;
    name: string;
    phoneNumber: string;
  };
  [ROUTES.ADD_FARMER_DETAILS]: {
    name?: string;
    phoneNumber?: string;
  };
  [ROUTES.ORDERS_LISTING]: {
    farmerId: string;
  };
  [ROUTES.ONGOING_CROPS_LISTING]: {
    farmerId: string;
    isEditAllowed: boolean;
  };
  [ROUTES.FARMER_PRODUCTS_LISTING]: {
    farmerId: string;
    isEditAllowed: boolean;
  };
  [ROUTES.DISEASE_TREATMENT]: {
    diseaseId: number;
    cropName: string;
    cropId: number;
  };
  [ROUTES.DIAGNOSIS_RESULT]: {
    diseaseId: number;
    plantixId: string;
    cropId: number;
    cropName: string;
  };
  [ROUTES.ORDER_DETAILS]: {
    orderId: string;
  };
  [ROUTES.FARMER_CREDIT_DETAILS]: { farmerId: string; name: string };
};

export type Farmer360HomeScreenProps = NativeStackScreenProps<
  RootStackParamList,
  ROUTES.FARMER_360_HOME
>;

export type FarmersListScreenProps = NativeStackScreenProps<
  RootStackParamList,
  ROUTES.FARMERS_LIST
>;

export type StartDiagnosisScreenProps = NativeStackScreenProps<
  RootStackParamList,
  ROUTES.START_DIAGNOSIS
>;

export type PreviousDiagnosisScreenProps = NativeStackScreenProps<
  RootStackParamList,
  ROUTES.PREVIOUS_DIAGNOSIS
>;

export type DiseaseDiagnosisScreenProps = NativeStackScreenProps<
  RootStackParamList,
  ROUTES.DISEASE_DIAGNOSIS
>;

export type AddFarmerScreenProps = NativeStackScreenProps<
  RootStackParamList,
  ROUTES.ADD_FARMER
>;

export type EditFarmerInfoScreenProps = NativeStackScreenProps<
  RootStackParamList,
  ROUTES.EDIT_FARMER_DETAILS
>;

export type AddFarmerInfoScreenProps = NativeStackScreenProps<
  RootStackParamList,
  ROUTES.ADD_FARMER_DETAILS
>;

export type OrderListingScreenProps = NativeStackScreenProps<
  RootStackParamList,
  ROUTES.ORDERS_LISTING
>;

export type OongoingCropsListingScreenProps = NativeStackScreenProps<
  RootStackParamList,
  ROUTES.ONGOING_CROPS_LISTING
>;

export type FarmerProductListingScreenProps = NativeStackScreenProps<
  RootStackParamList,
  ROUTES.FARMER_PRODUCTS_LISTING
>;

export type DiseaseTreatmentScreenProps = NativeStackScreenProps<
  RootStackParamList,
  ROUTES.DISEASE_TREATMENT
>;

export type DiagnosisResultScreenProps = NativeStackScreenProps<
  RootStackParamList,
  ROUTES.DIAGNOSIS_RESULT
>;

export type OrderDetailsScreenProps = NativeStackScreenProps<
  RootStackParamList,
  ROUTES.ORDER_DETAILS
>;

export type FarmerCreditDetailsScreenProps = NativeStackScreenProps<
  RootStackParamList,
  ROUTES.FARMER_CREDIT_DETAILS
>;
